import React, { useState, useEffect } from "react"
import { CircularProgress, Backdrop } from "@mui/material"
import useStore from "../Store"

function Spinner(props) {
    const { isSpinner } = useStore((state) => state.header)

    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: 9999 }}
            open={isSpinner} >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default Spinner;